<template>
  <span
    role="status"
    aria-live="polite"
    aria-label="Loading..."
    :class="
      spinnerVariant({
        variant,
        size,
      })
    "
  >
    <span class="sr-only">Loading...</span>
  </span>
</template>

<script lang="ts" setup>
import { tw } from '@/common/helpers';
import { cva, VariantProps } from 'class-variance-authority';

defineProps<{
  size?: SpinnerVariants['size'];
  variant?: SpinnerVariants['variant'];
}>();

const spinnerVariant = cva(tw`animate-spin rounded-full`, {
  variants: {
    variant: {
      primary: tw`border-b-primary text-primary-on`,
      tonal: tw`border-b-secondary-container text-secondary-container-on`,
      text: tw`border-b-primary text-primary`,
      // eslint-disable-next-line tailwindcss/no-custom-classname
      elevated: tw`border-b-primary text-primary`,
    },
    size: {
      // eslint-disable-next-line tailwindcss/no-unnecessary-arbitrary-value
      normal: tw`size-4 border-[1px]`,
    },
  },
  defaultVariants: {
    variant: 'primary',
    size: 'normal',
  },
});
type SpinnerVariants = VariantProps<typeof spinnerVariant>;
</script>
